import { makeStyles } from '@material-ui/core';

export default makeStyles({
  menuPage: {
    height: '100%',
    padding: '1rem 1rem 0.5rem',
    fontFamily: 'PP Object Sans',
    overflowY: 'hidden',
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
});
